import Tooltip from './Tooltip';

export default {
  install(Vue) {
    Vue.use(Tooltip);
  },
};
